import { EnumBase } from 'hay-core-react';

class PublicacaoLogStatusEnum extends EnumBase {
    constructor() {
        super([
            'main.publicacaolog.status.sucesso',
            'main.publicacaolog.status.falha',
            'main.publicacaolog.status.timeout',
        ]);
    }
}

export default new PublicacaoLogStatusEnum();
